<template lang="pug">
  .wrap.suche
    #content
      .block 
        h3.title(v-if="!loading") {{ totalHits }} {{ $t(`Suchergebnisse für {0}`, [$route.query.term]) }}
        search-input.searchinput
      search-filter(v-on:api-search="apiSearch")
      loading(v-if="loading")
      .uebersicht(ref="uebersicht" v-if="!loading && results.length > 0 && hasFilterFacets")       
        transition-group(name="list").grid
          fundus-tile(v-for="fundus in results" :fundus="fundus" :key="fundus.id").fundus
      .results(v-else-if="!loading") {{ $t(`Keine Ergebnisse`) }}
</template>

<script>
function debounce (fn, delay) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}
import TextHighlight from 'vue-text-highlight';
import FundusTile from '@/components/FundusTile.vue'
import { startSearch as apiStartSearch } from '@/api'
import Loading from '@/components/Loading.vue'
import Filter from '@/components/Filter/Filter.vue'
import searchInput from '@/components/SearchInput.vue'
export default {
  name: 'Suche',
  metaInfo () {
    return {
      title: 'Suche',
      meta: [
        { hid: 'description', name: 'description', content: `Suche` }
      ]
    }
  },
  data: () => ({
      loading: true,
      term: "",
      results: [],
      totalHits: 0,
  }),
  computed: {
    hasFilterFacets: function () {
      return Object.entries(this.$store.state.listFilter.facets).length > 0;
    }
  },
  methods: {
    strippedImg(img) {
      return img.replace("https://backend.kstarberlin.de/wp-content/uploads","")
    },
    apiSearch: debounce(async function() {
      this.results = []
      this.loading = true
      try {
          const res = await apiStartSearch({ term: this.term, ...this.$store.getters.meilisearchParam() })
          if(res.hits) {
            this.results = res.hits.filter((item) => item.thumbnail != null || item.imageLayers.length != 0)
          }
          this.totalHits = res.estimatedTotalHits
          delete res.facetDistribution.dimensions
          delete res.facetDistribution["condition"]
          delete res.facetDistribution["rentalPrice"]
          this.$store.commit('UPDATE_LIST_FILTER_FACETS', { facets: res.facetDistribution })  
          this.loading = false
      } catch (error) {
          setTimeout(()=> {        
             this.loading = false
          }, 250)
          console.log('Search error', error)
      }
    }, 250),
  },
  async created() {
    this.apiSearch()
  },
  watch: {
    '$store.state.listFilter.exclusions': function (newVal) {
        this.apiSearch()
        console.log("Search filter exclusions")
      },
    'term':function (newVal) {
      this.apiSearch();
      console.log("Search term")
    },
    '$route': function (to, from) {
      this.term = to.query.term;
    },
  },
  components: {
    Loading,
    'text-highlight': TextHighlight,
    FundusTile,
    'search-filter': Filter,
    searchInput,
  },
  mounted () {
    this.term = this.$route.query.term;
    window._paq.push(['setCustomUrl', window.location])
    window._paq.push(['setDocumentTitle', this.$metaInfo.title])
    window._paq.push(['trackPageView'])
  }
}
</script>

<style scoped lang="sass">
.searchinput
  margin-bottom: 20px
.uebersicht
  margin-top: 20px
.fixed
  position: fixed
  top: 0
  right: 0
.title
  text-align: center
  margin-bottom: 16px
  strong
    text-decoration: underline
.results
  display: grid
  grid-template-columns: repeat(7, 1fr)
  grid-column-gap: 8px
  grid-row-gap: 8px
.result
  width: 128px
  float: left
  margin: 8px
a
  color: #000
  &:hover
    color: #cc0000
.searchfilter
  z-index: 99
  position: relative
.facet .option
  display: inline-block
  padding: 0 8px 8px 0
  cursor: pointer
  &:hover
    text-decoration: underline
  &.active
    color: red
.grid
  display: grid
  //grid-template-columns: 25% 25% 25% 25%
  grid-template-columns: repeat(4, 1fr)
  grid-gap: 20px
  @media only screen and (max-width: 1000px)
    grid-template-columns: repeat(3, 1fr)
  @media only screen and (max-width: 769px)
    grid-template-columns: repeat(2, 1fr)
</style>
